import { Component, EventEmitter, Inject } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { FormGroup, FormControl } from '@angular/forms';

@Component({
  selector: 'aqualia-generic-confirm',
  templateUrl: './generic-confirm.component.html',
  styleUrls: ['./generic-confirm.component.css']
})
export class GenericConfirmComponent {

  MainTitle: string = "";
  SubTitle: string = "";

  showInputText: boolean = false;

  form: FormGroup;

  constructor(public dialogRef: MatDialogRef<GenericConfirmComponent>, @Inject(MAT_DIALOG_DATA) public data: any) {
    this.MainTitle = data.MainTitle;
    this.SubTitle = data.SubTitle;
    if (data.showInputText) {
      this.showInputText = true;
      this.form = new FormGroup({
        "Observations": new FormControl(''),
      });
    }
  }

  confirm() {
    if(this.showInputText){
      this.dialogRef.close({result: "OK", text : this.form.controls["Observations"].value});
    }
    else{      
      this.dialogRef.close("Ok");
    }
  }

  cancel() {
    this.dialogRef.close();
  }

}
